module.exports = __webpack_public_path__ + "img/vu.7713db5b.svg";